const work_surprise = `Hei Olga,
Minun piti vain kertoa yllätyksestä, jonka koin uudessa työssäni tänään!
Voitko uskoa, että he järjestivät minulle pienen tervetuliaisjuhlan?
Olin täysin yllättynyt, suoraan sanottuna.
Minulla ei ollut aavistustakaan, että he tekisivät niin paljon saadakseen minut tuntemaan oloni tervetulleeksi.
Se oli todella sydäntä lämmittävä ele, ja se sai minut tuntemaan oloni niin arvostetuksi.
Kaikki olivat niin ystävällisiä ja kannustavia, ja se auttoi ehdottomasti helpottamaan hermojani aloittaessani uudessa paikassa.
Olen jo nyt innostunut ja luottavainen tästä työstä.
Aion tutustua kollegoihini paremmin ja hyödyntää tätä mahdollisuutta parhaalla mahdollisella tavalla.
Se näyttää mahtavalta joukkueelta, enkä malta odottaa, että näen, mitä minua täällä on tarjolla.
Pidän sinut ajan tasalla kuinka asiat etenevät!
terveisiä`;

export default work_surprise;